import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';


const JobCard = ({ job, onSave }) => {
  const navigate = useNavigate();
  const [isSaved, setIsSaved] = useState(job?.isSaved || false);

  const handleSave = (e) => {
    e?.stopPropagation();
    setIsSaved(!isSaved);
    onSave(job?.id, !isSaved);
  };

  const handleCardClick = () => {
    navigate('/job-details', { state: { jobId: job?.id } });
  };

  const formatSalary = (min, max) => {
    const formatNumber = (num) => {
      if (num >= 10000000) return `${(num / 10000000)?.toFixed(1)}Cr`;
      if (num >= 100000) return `${(num / 100000)?.toFixed(1)}L`;
      return `${(num / 1000)?.toFixed(0)}K`;
    };
    return `₹${formatNumber(min)} - ₹${formatNumber(max)}`;
  };

  return (
    <div 
      onClick={handleCardClick}
      className="bg-card border border-border rounded-lg p-4 hover:shadow-modal transition-smooth cursor-pointer group"
    >
      <div className="flex items-start gap-4">
        <div className="w-14 h-14 rounded-lg overflow-hidden flex-shrink-0 bg-muted">
          <Image 
            src={job?.companyLogo} 
            alt={job?.companyLogoAlt}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <div className="flex-1 min-w-0">
              <h3 className="text-base font-semibold text-foreground group-hover:text-primary transition-smooth truncate">
                {job?.title}
              </h3>
              <p className="text-sm text-muted-foreground truncate">{job?.company}</p>
            </div>
            <button
              onClick={handleSave}
              className="flex-shrink-0 p-2 rounded-lg hover:bg-muted transition-smooth"
              aria-label={isSaved ? "Remove from saved jobs" : "Save job"}
            >
              <Icon 
                name={isSaved ? "Bookmark" : "Bookmark"} 
                size={20} 
                color={isSaved ? "var(--color-primary)" : "var(--color-muted-foreground)"}
                className={isSaved ? "fill-current" : ""}
              />
            </button>
          </div>

          <div className="flex flex-wrap items-center gap-3 mb-3">
            <div className="flex items-center gap-1.5 text-sm text-muted-foreground">
              <Icon name="MapPin" size={16} />
              <span>{job?.location}</span>
            </div>
            <div className="flex items-center gap-1.5 text-sm text-muted-foreground">
              <Icon name="Briefcase" size={16} />
              <span>{job?.experience}</span>
            </div>
            <div className="flex items-center gap-1.5 text-sm font-medium text-foreground">
              <Icon name="IndianRupee" size={16} />
              <span>{formatSalary(job?.salaryMin, job?.salaryMax)}</span>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2 mb-3">
            {job?.tags?.slice(0, 3)?.map((tag, index) => (
              <span 
                key={index}
                className="px-2 py-1 bg-muted text-xs font-medium text-foreground rounded"
              >
                {typeof tag === 'object' ? tag?.name : tag}
              </span>
            ))}
            {job?.tags?.length > 3 && (
              <span className="text-xs text-muted-foreground">+{job?.tags?.length - 3} more</span>
            )}
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              {job?.isRemote && (
                <span className="flex items-center gap-1 px-2 py-1 bg-success/10 text-success text-xs font-medium rounded">
                  <Icon name="Home" size={14} />
                  Remote
                </span>
              )}
              {job?.isUrgent && (
                <span className="flex items-center gap-1 px-2 py-1 bg-warning/10 text-warning text-xs font-medium rounded">
                  <Icon name="Zap" size={14} />
                  Urgent
                </span>
              )}
            </div>
            <span className="text-xs text-muted-foreground">{job?.postedTime}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobCard;